import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {HttpClient, HttpEventType, HttpHeaders} from '@angular/common/http';
import {finalize, Observable, Subscription} from 'rxjs';
import {FormControl, FormGroup} from '@angular/forms';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {map, startWith} from 'rxjs/operators';
import {MatChipInputEvent} from '@angular/material/chips';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatSelectionListChange} from '@angular/material/list';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SharedService} from '../../../services/shared.service';
import {ToastService} from '../../../services/toast.service';
import {environment} from '../../../../environments/environment';
import {HttpService} from '../../../services/http.service';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-export-diaglog',
  templateUrl: './export-diaglog.component.html',
  styleUrls: ['./export-diaglog.component.scss']
})
export class ExportDiaglogComponent implements OnInit {
  // @ts-ignore
  @ViewChild('rowsInput') rowsInput: ElementRef<HTMLInputElement>;
  @ViewChild('chipList') chipList: ElementRef<HTMLInputElement> | undefined;


  chipsInit: boolean = false;
  public stageRows: any = [
    {
      name: 'Title AI ⚙️',
      field: 'title_ai'
    },
    {
      name: 'Product ID',
      field: 'product_id'
    },
    {
      name: 'SKU',
      field: 'sku'
    },
    {
      name: 'BHS Shopify Published',
      field: 'shopify_published'
    },
    {
      name: 'MWS Shopify Published',
      field: 'mws_shopify_published'
    },
    {
      name: 'BHS Shopify ID',
      field: 'shopify_id'
    },
    {
      name: 'MWS Shopify ID',
      field: 'mws_shopify_id'
    },
    {
      name: 'Related Accessories',
      field:'related_products'
    },
    {
      name: 'Related Parts',
      field:'related_parts'
    },
    {
      name: 'Related Collections',
      field:'related_collections'
    },
    {
      name: 'Replacement SKU',
      field: 'replacement'
    },
    {
      name: 'Handle',
      field: 'handle'
    },
    {
      name: 'Brand',
      field: 'brand'
    },
    {
      name: 'Type',
      field: 'type'
    },
    {
      name: 'Description',
      field: 'description'
    },
    {
      name: 'Pricing ID',
      field: 'pricing_id'
    },
    {
      name: 'List Price',
      field: 'list_price'
    },
    {
      name: 'Cost Price',
      field: 'cost_price'
    },
    {
      name: 'BHS Sell Price',
      field: 'sell_price'
    },
    {
      name: 'MWS Sell Price',
      field: 'mws_sell_price'
    },
    {
      name: 'Out of Stock',
      field: 'out_of_stock'
    },
    {
      name: 'BH GAQ',
      field: 'bh_gaq'
    },
    {
      name: 'MW GAQ',
      field: 'mw_gaq'
    },
    {
      name: 'Pack Qty',
      field: 'pack_qty'
    },
    {
      name: 'Image',
      field: 'image'
    },
    {
      name: 'Datasheet',
      field: 'datasheet_new'
    },
    {
      name: 'Installation Instructions',
      field: 'installation_instructions'
    },
    {
      name: 'URL Manufacturer',
      field: 'url_manufacturer'
    },
    {
      name: 'Body',
      field: 'body_seo'
    },
    {
      name: 'Tags',
      field: 'tags'
    },
    {
      name: 'Vendor Tags',
      field: 'vendor_tags'
    },
    {
      name: 'Shipping Tag',
      field: 'shipping_tag'
    },
    {
      name: 'Google Category',
      field: 'google_category'
    },
    {
      name: 'ASM Tags',
      field: 'asm_tags'
    },
    {
      name: 'UPC/GTIN',
      field: 'upc_gtin'
    },
    {
      name: 'Weight LBS',
      field: 'weight_lbs'
    },
    {
      name: 'Title Prefix 1',
      field: 'title_prefix_1'
    },
    {
      name: 'Title Prefix 2',
      field: 'title_prefix_2'
    },
    {
      name: 'Title Prefix 3',
      field: 'title_prefix_3'
    },
    {
      name: 'Title Suffix 1',
      field: 'title_suffix_1'
    },
    {
      name: 'Title Suffix 2',
      field: 'title_suffix_2'
    },
    {
      name: 'Title Suffix 3',
      field: 'title_suffix_3'
    },
    {
      name: 'Body Prefix 1',
      field: 'body_prefix_1'
    },
    {
      name: 'Body Prefix 2',
      field: 'body_prefix_2'
    },
    {
      name: 'Body Prefix 3',
      field: 'body_prefix_3'
    },
    {
      name: 'Body Suffix 1',
      field: 'body_suffix_1'
    },
    {
      name: 'Body Suffix 2',
      field: 'body_suffix_2'
    },
    {
      name: 'Body Suffix 3',
      field: 'body_suffix_3'
    },
    {
      name: 'Notes',
      field: 'notes'
    },
    {
      name: 'Date Added',
      field: 'created_at'
    }
  ];
  public changesRows: any = [
    {
      name: 'Changed By',
      field: 'changed_by'
    },
    {
      name: 'Modification date',
      field: 'modification_date'
    },
    {
      name: 'Product ID',
      field: 'product_id'
    },
    {
      name: 'SKU',
      field: 'sku'
    },
    {
      name: 'BHS Shopify Published',
      field: 'bhs_shopify_published'
    },
    {
      name: 'MWS Shopify Published',
      field: 'mws_shopify_published'
    },
    {
      name: 'Related Accessories',
      field:'related_products'
    },
    {
      name: 'Related Parts',
      field:'related_parts'
    },
    {
      name: 'Related Collections',
      field:'related_collections'
    },
    {
      name: 'Replacement SKU',
      field: 'replacement'
    },
    {
      name: 'Handle',
      field: 'handle'
    },
    {
      name: 'Brand',
      field: 'brand'
    },
    {
      name: 'Type',
      field: 'type'
    },
    {
      name: 'Description',
      field: 'description'
    },
    {
      name: 'List Price',
      field: 'list_price'
    },
    {
      name: 'Cost Price',
      field: 'cost_price'
    },
    {
      name: 'BHS Sell Price',
      field: 'sell_price'
    },
    {
      name: 'MWS Sell Price',
      field: 'mws_sell_price'
    },
    {
      name: 'Out of Stock',
      field: 'out_of_stock'
    },
    {
      name: 'BH GAQ',
      field: 'bh_gaq'
    },
    {
      name: 'MW GAQ',
      field: 'mw_gaq'
    },
    {
      name: 'Pack Qty',
      field: 'pack_qty'
    },
    {
      name: 'Image',
      field: 'image'
    },
    {
      name: 'Datasheet',
      field: 'datasheet_new'
    },
    {
      name: 'Installation Instructions',
      field: 'installation_instructions'
    },
    {
      name: 'URL Manufacturer',
      field: 'url_manufacturer'
    },
    {
      name: 'Body',
      field: 'body_seo'
    },
    {
      name: 'Tags',
      field: 'tags'
    },
    {
      name: 'Vendor Tags',
      field: 'vendor_tags'
    },
    {
      name: 'Shipping Tag',
      field: 'shipping_tag'
    },
    {
      name: 'Google Category',
      field: 'google_category'
    },
    {
      name: 'ASM Tags',
      field: 'asm_tags'
    },
    {
      name: 'UPC/GTIN',
      field: 'upc_gtin'
    },
    {
      name: 'Weight LBS',
      field: 'weight_lbs'
    },
    {
      name: 'Title Prefix 1',
      field: 'title_prefix_1'
    },
    {
      name: 'Title Prefix 2',
      field: 'title_prefix_2'
    },
    {
      name: 'Title Prefix 3',
      field: 'title_prefix_3'
    },
    {
      name: 'Title Suffix 1',
      field: 'title_suffix_1'
    },
    {
      name: 'Title Suffix 2',
      field: 'title_suffix_2'
    },
    {
      name: 'Title Suffix 3',
      field: 'title_suffix_3'
    },
    {
      name: 'Body Prefix 1',
      field: 'body_prefix_1'
    },
    {
      name: 'Body Prefix 2',
      field: 'body_prefix_2'
    },
    {
      name: 'Body Prefix 3',
      field: 'body_prefix_3'
    },
    {
      name: 'Body Suffix 1',
      field: 'body_suffix_1'
    },
    {
      name: 'Body Suffix 2',
      field: 'body_suffix_2'
    },
    {
      name: 'Body Suffix 3',
      field: 'body_suffix_3'
    },
    {
      name: 'Notes',
      field: 'notes'
    }
  ];
  public historyRows: any = [
    {
      name: 'User',
      field: 'user'
    },
    {
      name: 'Modification date',
      field: 'modification_date'
    },
    {
      name: 'Product ID',
      field: 'product_id'
    },
    {
      name: 'SKU',
      field: 'sku'
    },
    {
      name: 'BHS Shopify Published',
      field: 'shopify_published'
    },
    {
      name: 'MWS Shopify Published',
      field: 'mws_shopify_published'
    },
    {
      name: 'Related Accessories',
      field:'related_products'
    },
    {
      name: 'Related Parts',
      field:'related_parts'
    },
    {
      name: 'Related Collections',
      field:'related_collections'
    },
    {
      name: 'Replacement SKU',
      field: 'replacement'
    },
    {
      name: 'Handle',
      field: 'handle'
    },
    {
      name: 'Brand',
      field: 'brand'
    },
    {
      name: 'Type',
      field: 'type'
    },
    {
      name: 'Description',
      field: 'description'
    },
    {
      name: 'List Price',
      field: 'list_price'
    },
    {
      name: 'Cost Price',
      field: 'cost_price'
    },
    {
      name: 'BHS Sell Price',
      field: 'sell_price'
    },
    {
      name: 'MWS Sell Price',
      field: 'mws_sell_price'
    },
    {
      name: 'Out of Stock',
      field: 'out_of_stock'
    },
    {
      name: 'BH GAQ',
      field: 'bh_gaq'
    },
    {
      name: 'MW GAQ',
      field: 'mw_gaq'
    },
    {
      name: 'Pack Qty',
      field: 'pack_qty'
    },
    {
      name: 'Image',
      field: 'image'
    },
    {
      name: 'Datasheet',
      field: 'datasheet_new'
    },
    {
      name: 'Installation Instructions',
      field: 'installation_instructions'
    },
    {
      name: 'URL Manufacturer',
      field: 'url_manufacturer'
    },
    {
      name: 'Body',
      field: 'body_seo'
    },
    {
      name: 'Tags',
      field: 'tags'
    },
    {
      name: 'Vendor Tags',
      field: 'vendor_tags'
    },
    {
      name: 'Shipping Tag',
      field: 'shipping_tag'
    },
    {
      name: 'Google Category',
      field: 'google_category'
    },
    {
      name: 'ASM Tags',
      field: 'asm_tags'
    },
    {
      name: 'UPC/GTIN',
      field: 'upc_gtin'
    },
    {
      name: 'Weight LBS',
      field: 'weight_lbs'
    },
    {
      name: 'Title Prefix 1',
      field: 'title_prefix_1'
    },
    {
      name: 'Title Prefix 2',
      field: 'title_prefix_2'
    },
    {
      name: 'Title Prefix 3',
      field: 'title_prefix_3'
    },
    {
      name: 'Title Suffix 1',
      field: 'title_suffix_1'
    },
    {
      name: 'Title Suffix 2',
      field: 'title_suffix_2'
    },
    {
      name: 'Title Suffix 3',
      field: 'title_suffix_3'
    },
    {
      name: 'Body Prefix 1',
      field: 'body_prefix_1'
    },
    {
      name: 'Body Prefix 2',
      field: 'body_prefix_2'
    },
    {
      name: 'Body Prefix 3',
      field: 'body_prefix_3'
    },
    {
      name: 'Body Suffix 1',
      field: 'body_suffix_1'
    },
    {
      name: 'Body Suffix 2',
      field: 'body_suffix_2'
    },
    {
      name: 'Body Suffix 3',
      field: 'body_suffix_3'
    },
    {
      name: 'Notes',
      field: 'notes'
    }
  ];
  // }, 'shopify_published', 'amazon_published', 'replacement', 'handle', 'brand', 'type', 'description', 'list_price', 'cost_price', 'sell_price', 'pack_qty', 'pack_text', 'asm_origin_zip', 'image', 'datasheet', 'installation_instructions', 'url_manufacturer', 'body_seo', 'tags', 'google_category', 'upc_gtin', 'weight_lbs', 'title_prefix_1', 'title_prefix_2', 'title_prefix_3', 'title_suffix_1', 'title_suffix_2', 'title_suffix_3', 'body_prefix_1', 'body_prefix_2', 'body_prefix_3', 'body_suffix_1', 'body_suffix_2', 'body_suffix_3'];
  // private productionRows: any = ['sku', 'shopify_published', 'amazon_published', 'replacement', 'handle', 'brand', 'type', 'description', 'list_price', 'cost_price', 'sell_price', 'pack_qty', 'pack_text', 'asm_origin_zip', 'image', 'datasheet', 'installation_instructions', 'url_manufacturer', 'body_seo', 'tags', 'google_category', 'upc_gtin', 'weight_lbs', 'title_prefix_1', 'title_prefix_2', 'title_prefix_3', 'title_suffix_1', 'title_suffix_2', 'title_suffix_3', 'body_prefix_1', 'body_prefix_2', 'body_prefix_3', 'body_suffix_1', 'body_suffix_2', 'body_suffix_3'];
  // private changesRows: any = ['sku', 'shopify_published', 'amazon_published', 'replacement', 'handle', 'brand', 'type', 'description', 'list_price', 'cost_price', 'sell_price', 'pack_qty', 'pack_text', 'asm_origin_zip', 'image', 'datasheet', 'installation_instructions', 'url_manufacturer', 'body_seo', 'tags', 'google_category', 'upc_gtin', 'weight_lbs', 'title_prefix_1', 'title_prefix_2', 'title_prefix_3', 'title_suffix_1', 'title_suffix_2', 'title_suffix_3', 'body_prefix_1', 'body_prefix_2', 'body_prefix_3', 'body_suffix_1', 'body_suffix_2', 'body_suffix_3'];
  // private changesHistoryRows: any = ['sku', 'shopify_published', 'amazon_published', 'replacement', 'handle', 'brand', 'type', 'description', 'list_price', 'cost_price', 'sell_price', 'pack_qty', 'pack_text', 'asm_origin_zip', 'image', 'datasheet', 'installation_instructions', 'url_manufacturer', 'body_seo', 'tags', 'google_category', 'upc_gtin', 'weight_lbs', 'title_prefix_1', 'title_prefix_2', 'title_prefix_3', 'title_suffix_1', 'title_suffix_2', 'title_suffix_3', 'body_prefix_1', 'body_prefix_2', 'body_prefix_3', 'body_suffix_1', 'body_suffix_2', 'body_suffix_3'];

  private endpoint: string = '';
  separatorKeysCodes: number[] = [ENTER, COMMA];
  rowCtrl = new FormControl('');
  filteredRows: Observable<any[]>;
  fullRowList: any[] = [];
  rows: any[] = [
    {
      field: 'sku',
      name: 'SKU'
    },
    {
      field: 'brand',
      name: 'Brand'
    },
    {
      field: 'type',
      name: 'Type'
    },
    {
      field: 'sell_price',
      name: 'BHS Sell Price'
    },
    {
      field: 'mws_sell_price',
      name: 'MWS Sell Price'
    },
    {
      field: 'list_price',
      name: 'List Price'
    },
  ];
  notSelectRows: any[] = [];
  allRows: any[] = [];
  filterModel: any;
  pending: boolean = false;
  public selectedRows: any = [];
  public selectedTitle = 'Filtered';
  public currentTable: string = '';

  //list of presets for export
  public presetsList: any = [
    {
      viewValue: 'All Fields',
      value: 'all'
    },{
      viewValue: 'No Fields',
      value: 'none'
    },
    {
      viewValue: 'For pricing updates',
      value: 'price'
    },
    {
      viewValue: 'For pricing(very short) updates',
      value: 'price_short'
    },
    {
      viewValue: 'For images only updates',
      value: 'img_only'
    },
    {
      viewValue: 'For image and docs updates',
      value: 'img_docs_only'
    },
    {
      viewValue: 'For weight updates',
      value: 'weight'
    },
    // {
    //   viewValue: 'Sync Errors',
    //   value: 'errors'
    // },
    {
      viewValue: 'For change history',
      value: 'history'
    }
  ];
  public fileFormat: any = [
    {
      viewValue: 'CSV',
      value: 'csv'
    },
    {
      viewValue: 'XLSX',
      value: 'xlsx'
    }
  ];
  public selectedFileFormat = 'xlsx';
  public selectedPreset = 'price';

  // Tag filter state
  public allTags: string[] = [];
  public filteredTags: string[] = [];
  public tagSearch = new FormControl('');
  public tagMode: 'all' | 'include' | 'exclude' = 'all';
  private selectedTagNames = new Set<string>();
  public selectAllTagsChecked: boolean = false;

  constructor(
    private http: HttpClient,
    private httpService: HttpService,
    private sharedService: SharedService,
    private toastService: ToastService,
    private dialogRef: MatDialogRef<ExportDiaglogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private storageService: StorageService,
  ) {
    this.currentTable = data.currentTable;
    this.filterModel = data.filterModel;
    if (this.currentTable === 'Staging') {
      this.endpoint = '/export/stage';
      this.rows = this.stageRows.map((item: any) => {
        return {...item};
      });
    } else if (this.currentTable === 'Production') {
      this.endpoint = '/export/production';
      this.rows = this.stageRows.slice();
    } else if (this.currentTable === 'Changes') {
      this.endpoint = '/export/changes';
      this.rows = this.changesRows.slice();
    } else if (this.currentTable === 'Change History') {
      this.endpoint = '/export/history';
      this.rows = this.historyRows.slice();
    }
    if (data.selectedIds) {
      this.selectedRows = data.selectedIds;
      this.selectedTitle = 'Selected';
      console.log('🟣 this.selectedRows', this.selectedRows);
    }
    this.chipsInit = true;
    // this.rows = data.columns.filter((c: any) => c.field !== 'shopify_sync_status' && c.field !== '_id' && c.field !== 'status');
    this.allRows = data.columns.filter((c: any) => c.field !== 'shopify_sync_status' && c.field !== '_id' && c.field !== 'status');
    this.fullRowList = data.columns.filter((c: any) => c.field !== 'shopify_sync_status' && c.field !== '_id' && c.field !== 'status');
    this.filteredRows = this.rowCtrl.valueChanges.pipe(
      startWith(null),
      map((row: any | null) => (row ? this._filter(row) : this.allRows.slice())),
    );
  }

  ngOnInit(): void {
    this.onPresetChange({value: 'price'});
    this.loadTags();
    this.setupTagSearch();
  }

  private setupTagSearch(): void {
    this.tagSearch.valueChanges.subscribe((q: string | null) => {
      const searchTerm = (q || '').toLowerCase().trim();
      console.log('Tag search:', searchTerm, 'Total tags:', this.allTags.length); // Debug log

      if (searchTerm.length >= 2) { // Only search when user types at least 2 characters
        const matches = this.allTags.filter(t => t.toLowerCase().includes(searchTerm));
        // Limit results to prevent UI freeze with large datasets
        this.filteredTags = matches.slice(0, 500); // Show max 500 results
        if (matches.length > 500) {
          console.log(`⚠️ Limited to 500 results (${matches.length} total matches)`);
        }
      } else if (searchTerm.length === 0) {
        // Show nothing when search is empty (too many to display)
        this.filteredTags = [];
      } else {
        // Show message to type more characters
        this.filteredTags = [];
      }
      console.log('Filtered tags:', this.filteredTags.length); // Debug log
      this.updateSelectAllState();
    });
  }

  //export presets fields
  onPresetChange(event: any) {
    this.selectedPreset = event.value;
    if (event.value === 'price' && (this.currentTable === 'Production' || this.currentTable === 'Staging')) {
      this.chipsInit = false;
      this.rows = [
        {field: 'pricing_id', name: 'Pricing ID'},
        {field: 'product_id', name: 'Product ID'},
        {field: 'handle', name: 'Handle'},
        {field: 'brand', name: 'Brand'},
        {field: 'sku', name: 'SKU'},
        {field: 'description', name: 'Description'},
        {field: 'shopify_published', name: 'BHS Shopify Published'},
        {field: 'mws_shopify_published', name: 'MWS Shopify Published'},
        {field: 'replacement', name: 'Replacement SKU'},
        {field: 'pack_qty', name: 'Pack Qty'},
        {field: 'tags', name: 'Tags'},
        {field: 'shipping_tag', name: 'Shipping Tag'},
        {field: 'asm_tags', name: 'ASM Tags'},
        {field: 'weight_lbs', name: 'Weight LBS'},
        {field: 'notes', name: 'Notes'},
        {field: 'list_price', name: 'List Price'},
        {field: 'cost_price', name: 'Cost Price'},
        {field: 'sell_price', name: 'BHS Sell Price'},
        {field: 'mws_sell_price', name: 'MWS Sell Price'},
        {field: 'out_of_stock', name: 'Out of Stock'},
        {field: 'bh_gaq', name: 'BH GAQ'},
        {field: 'mw_gaq', name: 'MW GAQ'},
        {field: 'created_at', name: 'Date Added'}
      ];
      this.chipsInit = true;
    }else if(event.value === 'price_short' && (this.currentTable === 'Production' || this.currentTable === 'Staging')) {
      this.chipsInit = false;
      this.rows = [
        {field: 'pricing_id', name: 'Pricing ID'},
        {field: 'product_id', name: 'Product ID'},
        {field: 'sku', name: 'SKU'},
        {field: 'brand', name: 'Brand'},
        {field: 'shopify_published', name: 'BHS Shopify Published'},
        {field: 'mws_shopify_published', name: 'MWS Shopify Published'},
        {field: 'replacement', name: 'Replacement SKU'},
        {field: 'description', name: 'Description'},
        {field: 'list_price', name: 'List Price'},
        {field: 'cost_price', name: 'Cost Price'},
        {field: 'sell_price', name: 'BHS Sell Price'},
        {field: 'mws_sell_price', name: 'MWS Sell Price'},
        {field: 'out_of_stock', name: 'Out of Stock'},
        {field: 'bh_gaq', name: 'BH GAQ'},
        {field: 'mw_gaq', name: 'MW GAQ'},
        {field: 'tags', name: 'Tags'},
        {field: 'notes', name: 'Notes'},
        {field: 'created_at', name: 'Date Added'}
      ];
      this.chipsInit = true;
    }else if(event.value === 'img_only' && (this.currentTable === 'Production' || this.currentTable === 'Staging')) {
      this.chipsInit = false;
      this.rows = [
        {field: 'product_id', name: 'Product ID'},
        {field: 'sku', name: 'SKU'},
        {field: 'brand', name: 'Brand'},
        {field: 'image', name: 'Image'},
        {field: 'notes', name: 'Notes'},
        {field: 'created_at', name: 'Date Added'}
      ];
      this.chipsInit = true;
    }else if(event.value === 'img_docs_only' && (this.currentTable === 'Production' || this.currentTable === 'Staging')) {
      this.chipsInit = false;
      this.rows = [
        {field: 'product_id', name: 'Product ID'},
        {field: 'sku', name: 'SKU'},
        {field: 'brand', name: 'Brand'},
        {field: 'image', name: 'Image'},
        {field: 'datasheet_new', name: 'Datasheet'},
        {field: 'installation_instructions', name: 'Installation Instructions'},
        {field: 'url_manufacturer', name: 'URL Manufacturer'},
        {field: 'notes', name: 'Notes'},
        {field: 'created_at', name: 'Date Added'}
      ];
      this.chipsInit = true;
    }else if(event.value === 'weight' && (this.currentTable === 'Production' || this.currentTable === 'Staging')) {
      this.chipsInit = false;
      this.rows = [
        {field: 'product_id', name: 'Product ID'},
        {field: 'sku', name: 'SKU'},
        {field: 'brand', name: 'Brand'},
        {field: 'shipping_tag', name: 'Shipping Tag'},
        {field: 'asm_tags', name: 'ASM Tags'},
        {field: 'weight_lbs', name: 'Weight LBS'},
        {field: 'notes', name: 'Notes'},
        {field: 'created_at', name: 'Date Added'}
      ];
      this.chipsInit = true;
    }else if(event.value === 'errors' && (this.currentTable === 'Production' || this.currentTable === 'Staging')) {
      this.chipsInit = false;
      this.rows = [
        {field: 'status', name: 'Status'},
        {field: 'pricing_id', name: 'Pricing ID'},
        {field: 'product_id', name: 'Product ID'},
        {field: 'handle', name: 'Handle'},
        {field: 'sku', name: 'SKU'},
        {field: 'shopify_published', name: 'BHS Shopify Published'},
        {field: 'syncErrorMessage', name: 'BHS Sync Error Message'},
        {field: 'mws_shopify_published', name: 'MWS Shopify Published'},
        {field: 'mws_syncErrorMessage', name: 'MWS Sync Error Message'}
      ];
      this.chipsInit = true;
    }
    else if(event.value === 'none' && (this.currentTable === 'Production' || this.currentTable === 'Staging')) {
      this.chipsInit = false;
      this.rows = [
        {field: 'product_id', name: 'Product ID'},
      ];
      this.chipsInit = true;
    }
    else {
      this.resetSelectedFields();
    }
  }
  onChange(event: any) {
    this.selectedFileFormat = event.value;
  }

  resetSelectedFields(): void {
    this.chipsInit = false;
    console.log('this.selectedPreset', this.selectedPreset);
    this.selectedPreset = 'all';
    if (this.currentTable === 'Staging') {
      this.rows = this.stageRows.slice();
    } else if (this.currentTable === 'Production') {
      this.rows = this.stageRows.slice();
    } else if (this.currentTable === 'Changes') {
      this.rows = this.changesRows.slice();
    } else if (this.currentTable === 'Change History') {
      this.rows = this.historyRows.slice();
    }
    this.chipsInit = true;
  }

  onExport() {
    // this.httpService.get(environment.API_PATH + '/queues').subscribe((res: any) => {
    //   if (res.export.lock === false) {
        if (this.rows.length) {
          const body: any = {
            type: this.selectedFileFormat,
            rowGroupCols: [],
            groupKeys: [],
            filterModel: this.filterModel,
            selectedProducts: this.selectedRows,
            sortModel: [],
            currentTable: this.currentTable,
            tagFilter: {
              mode: this.tagMode,
              tags: Array.from(this.selectedTagNames)
            }
          };

          if (this.currentTable === 'Staging' || this.currentTable === 'Production') {
            // body['selectedRow'] = this.stageRows.map((r: any) => r.field.replace('_id', ''));
            body['selectedRow'] = this.rows.map((r: any) => r.field);
          } else if (this.currentTable === 'Changes') {
            // body['selectedRow'] = this.changesRows.map((r: any) => r.field.replace('_id', ''));
            body['selectedRow'] = this.rows.map((r: any) => r.field);
          } else if (this.currentTable === 'Change History') {
            // body['selectedRow'] = this.historyRows.map((r: any) => r.field.replace('_id', ''));
            body['selectedRow'] = this.rows.map((r: any) => r.field);
          }

          this.pending = true;
          this.sharedService.exportMessageId = this.toastService.info('Data is being exported...', '', {timeOut: 0}).toastId;

          // setTimeout(() => {
          this.httpService.post(environment.API_PATH + this.endpoint, body).subscribe((res: any) => {
            this.pending = false;
          });
          this.dialogRef.close();
          // }, 500);
        } else {
          this.toastService.warning('Select at least one field');
        }
    //   } else {
    //     this.toastService.info('The process is occupied by another user.');
    //   }
    // });
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.rows, event.previousIndex, event.currentIndex);
  }

  remove(row: any) {
    console.log('remove', row);
    const index = this.rows.indexOf(row);

    if (index >= 0) {
      this.rows.splice(index, 1);
    }

    const newRows = this.fullRowList.filter(r => {
      if (r.field !== row.field) {
        return {
          field: r.field,
          name: r.name
        }
      }
      return false;
    });

    this.filteredRows = this.rowCtrl.valueChanges.pipe(
      startWith(null),
      map((row: any | null) => {
        if (row) {
          return this._filter(row);
        } else {
          return newRows;
        }
      }),
    );
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    console.log('selected');
    this.rows.push(event.option.value);
    this.rowsInput.nativeElement.value = '';
    this.rowCtrl.setValue(null);

    const index = this.allRows.findIndex(i => i.field === event.option.value.field);
    this.allRows.splice(index, 1);

    this.filteredRows = this.rowCtrl.valueChanges.pipe(
      startWith(null),
      map((row: any | null) => {
        if (row) {
          return this._filter(row);
        } else {
          return this.allRows.slice();
        }
      }),
    );

  }

  private _filter(value: any): string[] {
    console.log('_filter');
    const filterValue = value.field ? value.field.toLowerCase() : value.toLowerCase();
    return this.allRows.filter(row => row.field.toLowerCase().includes(filterValue));
  }

  // Getter to return available fields that are not already selected
  get availableFields() {
    // Return fields not already selected
    return this.stageRows
    .filter((field: any) => !this.rows.some(row => row.name === field.name))
    .sort((a: any, b: any) => a.name.localeCompare(b.name));
  }

  addField(field: any) {
    this.rows.push(field);
  }

  // Tags: load and selection helpers
  async loadTags() {
    try {
      console.log('🏷️ Starting to load tags...'); // Debug log
      console.log('🌐 API endpoint would be:', `${window.location.origin}/api/tag`);

      // First check if tags are already loaded synchronously (like grid filtering does)
      console.log('🔍 Checking storageService.tags directly:', this.storageService.tags);
      if (this.storageService.tags && Array.isArray(this.storageService.tags) && this.storageService.tags.length > 0) {
        console.log('✅ Found existing tags in storageService:', this.storageService.tags.length);
        this.processTags(this.storageService.tags);
        return;
      }

      // Try to get tags from StorageService async method
      const tags = await this.storageService.getTags();
      console.log('📦 Raw tags from StorageService:', tags); // Debug log
      console.log('📊 Tags type:', typeof tags, 'Array?', Array.isArray(tags), 'Length:', tags?.length);

      // Check if we have tags data
      if (!tags || !Array.isArray(tags)) {
        console.warn('No tags data received or invalid format:', tags);
        // Try to get from local storage as fallback
        const localTags = this.storageService.tags;
        console.log('Fallback to local storage tags:', localTags);
        if (localTags && Array.isArray(localTags)) {
          this.processTags(localTags);
          return;
        }
        this.allTags = [];
        this.filteredTags = [];
        return;
      }

      this.processTags(tags);
    } catch (e) {
      console.error('Failed to load tags', e);
      // Try fallback to existing tags in service
      const fallbackTags = this.storageService.tags;
      if (fallbackTags && Array.isArray(fallbackTags)) {
        console.log('Using fallback tags from service:', fallbackTags);
        this.processTags(fallbackTags);
      } else {
        this.allTags = [];
        this.filteredTags = [];
      }
    }
  }

  private processTags(tags: any[]) {
    // StorageService returns objects [{_id, name}], but we need names (strings)
    const names = tags.map((t: any) => t?.name).filter((n: any) => typeof n === 'string' && n.trim().length);
    console.log('Extracted tag names:', names.length, names.slice(0, 5)); // Debug log

    this.allTags = Array.from(new Set(names)).sort((a, b) => a.localeCompare(b));

    // Performance fix: Don't render all tags initially, only show when searching
    // 147k+ tags would freeze the browser
    console.warn(`⚠️ Large tag dataset (${this.allTags.length} tags) - limiting display for performance`);
    this.filteredTags = []; // Start empty, populate on search
    console.log('Final processed tags:', this.allTags.length, '(displaying limited set)'); // Debug log
  }

  public isTagSelected(tag: string): boolean {
    return this.selectedTagNames.has(tag);
  }

  public toggleTag(tag: string): void {
    if (this.selectedTagNames.has(tag)) {
      this.selectedTagNames.delete(tag);
    } else {
      this.selectedTagNames.add(tag);
    }
    this.updateSelectAllState();
  }

  public onTagSelectionChange(event: MatSelectionListChange): void {
    // Clear current selections
    this.selectedTagNames.clear();

    // Add all selected options
    if (event.source && event.source.selectedOptions) {
      event.source.selectedOptions.selected.forEach((option: any) => {
        this.selectedTagNames.add(option.value);
      });
    }

    this.updateSelectAllState();
    console.log('Selected tags:', Array.from(this.selectedTagNames)); // Debug log
  }

  public toggleSelectAllTags(): void {
    if (this.selectAllTagsChecked) {
      // Unselect all
      this.selectedTagNames.clear();
      this.selectAllTagsChecked = false;
    } else {
      // Select all currently filtered tags
      for (const t of this.filteredTags) this.selectedTagNames.add(t);
      this.selectAllTagsChecked = true;
    }
  }

  private updateSelectAllState() {
    if (!this.filteredTags.length) {
      this.selectAllTagsChecked = false;
      return;
    }
    this.selectAllTagsChecked = this.filteredTags.every(t => this.selectedTagNames.has(t));
  }

  public trackByTag(index: number, tag: string): string {
    return tag;
  }

  // Debug method - can be called from browser console
  public async testTagsAPI() {
    console.log('Testing direct API call...');
    try {
      const result = await this.httpService.get(environment.API_PATH + '/tag').toPromise();
      console.log('Direct API result:', result);
      return result;
    } catch (error) {
      console.error('Direct API error:', error);
      return null;
    }
  }

  // Check authentication status
  public checkAuth() {
    console.log('=== Authentication Debug ===');
    console.log('accessToken:', localStorage.getItem('accessToken'));
    console.log('refreshToken:', localStorage.getItem('refreshToken'));
    console.log('user:', localStorage.getItem('user'));
    console.log('currentUser:', localStorage.getItem('currentUser'));

    // Check all localStorage keys
    console.log('All localStorage keys:');
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        console.log(`  ${key}:`, localStorage.getItem(key));
      }
    }
  }
}
